import {
  Button,
  Heading,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import {faGoogle} from '@fortawesome/free-brands-svg-icons'
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import {USER_SIGN_UP} from '../../constants/routes'
import {getRedirectTo, setRedirectionCookies} from '../../utils/loginHelper'
import DarkModalContainer from './Components/DarkModalContainer'
import useTranslation from 'next-translate/useTranslation'
import {SUPPORTED_LANGUAGES} from '../../constants/languages'
import {useSignIn} from '../../hooks/useSignIn'

interface Props {
  isOpen: boolean
  onClose: () => void
  textLanguageToRecover?: SUPPORTED_LANGUAGES
  inputsToRecover?: any
  optionsToRecover?: any[]
}

const LoginModal = ({
  isOpen,
  onClose,
  inputsToRecover,
  optionsToRecover,
  textLanguageToRecover,
}: Props) => {
  const theme = useTheme()
  const [, signIn] = useSignIn()

  const {t} = useTranslation('login')

  const handleGoogleLogin = async () => {
    setRedirectionCookies(window.location.href, inputsToRecover, optionsToRecover)
    try {
      await signIn({provider: 'google'}, {redirectTo: getRedirectTo()})
    } catch (e: any) {
      const showToast = await import('../../utils/showToast').then(mod => mod.showToast)
      showToast(e.message, 'error')
    }
  }

  return (
    <DarkModalContainer isOpen={isOpen} onClose={onClose}>
      <ModalHeader p={0} mb={10}>
        <Heading textAlign='center' variant='large' color={theme.colors.text.basic}>
          {t('login_modal_title')}
        </Heading>
      </ModalHeader>
      <ModalBody p={0}>
        <Text variant='medium' color={theme.colors.text.basic} mb={10} textAlign='center'>
          {t('login_modal_description')}
        </Text>
        <VStack spacing={5} p={0} w='full'>
          <Button
            variant='loginButton'
            color={theme.colors.text.basic}
            onClick={handleGoogleLogin}
            leftIcon={<FontAwesomeIcon icon={faGoogle} />}>
            {t('login_modal_google')}
          </Button>
          <Link href={USER_SIGN_UP} passHref>
            <Button
              variant='loginButton'
              color={theme.colors.text.basic}
              onClick={() => {
                setRedirectionCookies(
                  window.location.href,
                  inputsToRecover,
                  optionsToRecover,
                  textLanguageToRecover
                )
              }}
              leftIcon={<FontAwesomeIcon icon={faEnvelope} />}>
              {t('login_modal_email')}
            </Button>
          </Link>
        </VStack>
      </ModalBody>
      <ModalFooter pb={0} justifyContent='center' mt={5}>
        <Button variant='textLightPrimary' color={theme.colors.text.basic} onClick={onClose}>
          {t('common:close_button')}
        </Button>
      </ModalFooter>
    </DarkModalContainer>
  )
}

export default LoginModal
